var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#fe818c"}},[_c('Header'),_c('div',{staticClass:"flex-wrapper"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }